import '../sass/single-bonus-book-about.scss';

(() => {
    const $singleBonusBookAboutTemplateParts = document.querySelectorAll('.single-bonus-book-about');

    if (!$singleBonusBookAboutTemplateParts) return;

    $singleBonusBookAboutTemplateParts.forEach($singleBonusBookAboutTemplatePart => {
        const $terms = $singleBonusBookAboutTemplatePart.querySelector('.single-bonus-book-about__terms');
        const $showTermsButton = $singleBonusBookAboutTemplatePart.querySelector('.single-bonus-book-about__show-terms-button');
        const $closeTermsButton = $singleBonusBookAboutTemplatePart.querySelector('.single-bonus-book-about__close-terms-button');
        const $termsDetails = $singleBonusBookAboutTemplatePart.querySelector('.single-bonus-book-about__terms-details');

        const initTerms = () => {
            if (!$terms || !$showTermsButton || !$closeTermsButton || !$termsDetails) return;

            $showTermsButton.addEventListener('click', () => {
                $termsDetails.style.height = `${$termsDetails.scrollHeight}px`;

                $terms.classList.add('single-bonus-book-about__terms--show');

                window.requestAnimationFrame(() => {
                    setTimeout(() => {
                        $termsDetails.style.height = '';
                    }, 300);
                });
            });

            $closeTermsButton.addEventListener('click', () => {
                $termsDetails.style.height = `${$termsDetails.scrollHeight}px`;

                $terms.classList.remove('single-bonus-book-about__terms--show');

                window.requestAnimationFrame(() => {
                    $termsDetails.style.height = '';
                });
            });
        };

        initTerms();
    });
})();
